// Getters
export const FETCH_REWARDS_ACCOUNTS =
  "premierCollectionRewards/FETCH_REWARDS_ACCOUNTS";
export type FETCH_REWARDS_ACCOUNTS = typeof FETCH_REWARDS_ACCOUNTS;

// Setters
export const SET_REWARDS_ACCOUNTS =
  "premierCollectionRewards/SET_REWARDS_ACCOUNTS";
export type SET_REWARDS_ACCOUNTS = typeof SET_REWARDS_ACCOUNTS;

export const SET_SELECTED_ACCOUNT_REFERENCE_ID =
  "premierCollectionRewards/SET_SELECTED_ACCOUNT_REFERENCE_ID";
export type SET_SELECTED_ACCOUNT_REFERENCE_ID =
  typeof SET_SELECTED_ACCOUNT_REFERENCE_ID;

export const SET_FETCH_REWARDS_ACCOUNTS_CALL_STATE_FAILED =
  "premierCollectionRewards/SET_FETCH_REWARDS_ACCOUNTS_CALL_STATE_FAILED";
export type SET_FETCH_REWARDS_ACCOUNTS_CALL_STATE_FAILED =
  typeof SET_FETCH_REWARDS_ACCOUNTS_CALL_STATE_FAILED;

export const SET_IS_FIRST_LAUNCH =
  "premierCollectionRewards/SET_IS_FIRST_LAUNCH";
export type SET_IS_FIRST_LAUNCH = typeof SET_IS_FIRST_LAUNCH;

export const SET_AGENT_EMAIL = "premierCollectionRewards/SET_AGENT_EMAIL";
export type SET_AGENT_EMAIL = typeof SET_AGENT_EMAIL;

export const SET_USER_INFO = "premierCollectionRewards/SET_USER_INFO";
export type SET_USER_INFO = typeof SET_USER_INFO;

// Corporate Travel
export const SET_AUTO_APPROVAL = "hotelRewards/SET_AUTO_APPROVAL";
export type SET_AUTO_APPROVAL = typeof SET_AUTO_APPROVAL;
